import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { useImageLoading, SkeletonLoading } from '@fiverr-private/identification_core';
import image from '../../../assets/brief_and_match.png';
import { appTranslate } from '../../../i18n';
import { responsiveImg } from '../../../shared/styles/index.ve.css';

export const BriefAndMatchBanner = () => {
    const { loading, onLoad } = useImageLoading(image);

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <Container width="100%" paddingY="14" paddingX="12" position="absolute">
                    <Typography as="h1" color="white" marginBottom="6" fontWeight="bold" size="h_xl">
                        {appTranslate('identification.banner.new_brief_and_match.title', {
                            templates: {
                                accent: (text?: string) => (
                                    <Typography as="span" color="orange_700">
                                        {text}
                                    </Typography>
                                ),
                            },
                        })}
                    </Typography>
                    <Text as="p" size="b_lg" color="white">
                        {appTranslate('identification.banner.new_brief_and_match.subtitle')}
                    </Text>
                </Container>

                <img
                    src={image}
                    onLoad={onLoad}
                    className={responsiveImg}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                />
            </Container>
        </SkeletonLoading>
    );
};
